// // // $(document).ready(function () {
// // //   function setupFooterAccordion() {
// // //     if ($(window).width() <= 991) {
// // //       $('footer.clFooter .menuBox h3').off('click').on('click', function () {
// // //         var $thisMenuBox = $(this).closest('.menuBox');
// // //         var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
// // //         var $thisSvg = $(this).find('svg');
// // //         $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
// // //         $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
// // //         $thisLinks.stop(true, true).slideToggle();
// // //         $thisSvg.toggleClass('rotated');
// // //       });
// // //     } else {
// // //       // Desktop: Show all and unbind click
// // //       $('footer.clFooter .menuBox .menuBoxLinks').show();
// // //       $('footer.clFooter .menuBox h3').off('click');
// // //       $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
// // //     }
// // //   }
// // //   setupFooterAccordion();
// // //   $(window).resize(setupFooterAccordion);
// // // });
// // // // Popup Open

// // // $('.clBtnDrawer').on('click', function() {
// // //   $('#cl-popup--drawer').addClass('active');
// // // });
// // $(document).ready(function () {
// //   function setupFooterAccordion() {
// //     if ($(window).width() <= 991) {
// //       $('footer.clFooter .menuBox h3').off('click').on('click', function () {
// //         var $thisMenuBox = $(this).closest('.menuBox');
// //         var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
// //         var $thisSvg = $(this).find('svg');
// //         $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
// //         $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
// //         $thisLinks.stop(true, true).slideToggle();
// //         $thisSvg.toggleClass('rotated');
// //       });
// //     } else {
// //       // Desktop: Show all and unbind click
// //       $('footer.clFooter .menuBox .menuBoxLinks').show();
// //       $('footer.clFooter .menuBox h3').off('click');
// //       $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
// //     }
// //   }
// //   setupFooterAccordion();
// //   $(window).resize(setupFooterAccordion);
// // });

// // // Popup Open

// // // $('.clBtnDrawer').on('click', function() {
// // //   $('#cl-popup--overlay, #cl-popup--drawer').addClass('active');
// // // });

// // document.addEventListener('DOMContentLoaded', function () {

// //   // Dropdown Link Footer

// //   const footerDropLink = document.querySelectorAll('a.dropmenu_footer');

// //   footerDropLink.forEach(btn => {
// //     btn.addEventListener('click', function (e) {
// //       e.preventDefault();
// //       const footerDropdown = this.nextElementSibling;

// //       if(footerDropdown && footerDropdown.classList.contains('menuBoxLinks-detail')){
// //         this.classList.toggle('active');
// //         footerDropdown.classList.toggle('active');
// //       }
// //     });
// //   });


// //   // Accessibility

// //   const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
// //   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
// //   const videoFirst = document.querySelector('.video-desktop video');
// //   const videoSeconde = document.querySelector('.video-mobile video');
// //   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
// //   const videoOn = document.querySelector('.video-on');
// //   const videoOff = document.querySelector('.video-pause');

// //  toggleLabel.forEach(btn => {
// //   btn.addEventListener('click', function() {
// //     const isActive = this.classList.toggle('active'); // toggle only clicked button

// //     // Update media elements
// //     mediaElements.forEach(el => {
// //       el.style.filter = isActive ? 'brightness(0.5)' : '';
// //     });

// //     // Update videos
// //     if(isActive){
// //       videoOff.style.display = 'inline-flex';
// //       videoOn.style.display = 'none';
// //       videoFirst.pause();
// //       videoSeconde.pause();
// //     } else {
// //       videoOff.style.display = 'none';
// //       videoOn.style.display = 'inline-flex';
// //       videoFirst.play();
// //       videoSeconde.play();
// //     }

// //     // Update all banner overlays
// //     btmOverlays.forEach(overlay => {
// //       if(isActive){
// //         overlay.classList.add('active');
// //       } else {
// //         overlay.classList.remove('active');
// //       }
// //     });
// //   });
// // });


// // });
// $(document).ready(function () {
//   function setupFooterAccordion() {
//     if ($(window).width() <= 991) {
//       $('footer.clFooter .menuBox h3').off('click').on('click', function () {
//         var $thisMenuBox = $(this).closest('.menuBox');
//         var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
//         var $thisSvg = $(this).find('svg');
//         $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
//         $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
//         $thisLinks.stop(true, true).slideToggle();
//         $thisSvg.toggleClass('rotated');
//       });
//     } else {
//       // Desktop: Show all and unbind click
//       $('footer.clFooter .menuBox .menuBoxLinks').show();
//       $('footer.clFooter .menuBox h3').off('click');
//       $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
//     }
//   }
//   setupFooterAccordion();
//   $(window).resize(setupFooterAccordion);
// });

// // Popup Open

// // $('.clBtnDrawer').on('click', function() {
// //   $('#cl-popup--overlay, #cl-popup--drawer').addClass('active');
// // });

// document.addEventListener('DOMContentLoaded', function () {

//   // Dropdown Link Footer

//   const footerDropLink = document.querySelectorAll('a.dropmenu_footer');

//   footerDropLink.forEach(btn => {
//     btn.addEventListener('click', function (e) {
//       e.preventDefault();
//       const footerDropdown = this.nextElementSibling;

//       if(footerDropdown && footerDropdown.classList.contains('menuBoxLinks-detail')){
//         this.classList.toggle('active');
//         footerDropdown.classList.toggle('active');
//       }
//     });
//   });


//   // Accessibility

// //   const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
// //   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
// //   const videoFirst = document.querySelector('.video-desktop video');
// //   const videoSeconde = document.querySelector('.video-mobile video');
// //   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
// //   const videoOn = document.querySelector('.video-on');
// //   const videoOff = document.querySelector('.video-pause');

// //  toggleLabel.forEach(btn => {
// //   btn.addEventListener('click', function() {
// //     const isActive = this.classList.toggle('active'); // toggle only clicked button

// //     // Update media elements
// //     mediaElements.forEach(el => {
// //       el.style.filter = isActive ? 'brightness(0.5)' : '';
// //     });

// //     // Update videos
// //     if(isActive){
// //       videoOff.style.display = 'inline-flex';
// //       videoOn.style.display = 'none';
// //       videoFirst.pause();
// //       videoSeconde.pause();
// //     } else {
// //       videoOff.style.display = 'none';
// //       videoOn.style.display = 'inline-flex';
// //       videoFirst.play();
// //       videoSeconde.play();
// //     }

// //     // Update all banner overlays
// //     btmOverlays.forEach(overlay => {
// //       if(isActive){
// //         overlay.classList.add('active');
// //       } else {
// //         overlay.classList.remove('active');
// //       }
// //     });
// //   });
// // });
// const savedState = sessionStorage.getItem('videoPaused') === 'true';

// // --- Helper function to apply state ---
// function applyVideoState(isPaused) {
//   const toggleLabels = document.querySelectorAll('.cl-accessibility__toggle-label');
//   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
//   const videoFirst = document.querySelector('.video-desktop video');
//   const videoSeconde = document.querySelector('.video-mobile video');
//   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
//   const videoOn = document.querySelector('.video-on');
//   const videoOff = document.querySelector('.video-pause');

//   // Apply toggle button state
//   toggleLabels.forEach(btn => btn.classList.toggle('active', isPaused));

//   // Apply media filter
//   mediaElements.forEach(el => el.style.filter = isPaused ? 'brightness(0.5)' : '');

//   // Videos
//   if(videoFirst && videoSeconde && videoOn && videoOff){
//     if(isPaused){
//       videoFirst.pause();
//       videoSeconde.pause();
//       videoOn.style.display = 'none';
//       videoOff.style.display = 'inline-flex';
//     } else {
//       videoFirst.play();
//       videoSeconde.play();
//       videoOn.style.display = 'inline-flex';
//       videoOff.style.display = 'none';
//     }
//   }

//   // Banner overlays
//   btmOverlays.forEach(overlay => overlay.classList.toggle('active', isPaused));
// }

// // --- Apply saved state on page load ---
// applyVideoState(savedState);

// // --- Attach click handler if toggle exists ---
// const toggleLabels = document.querySelectorAll('.cl-accessibility__toggle-label');
// if(toggleLabels.length > 0){
//   toggleLabels.forEach(btn => {
//     btn.addEventListener('click', function() {
//       const isActive = this.classList.toggle('active');
//       sessionStorage.setItem('videoPaused', isActive);
//       applyVideoState(isActive);
//     });
//   });
// }


// });
$(document).ready(function () {
  function setupFooterAccordion() {
    if ($(window).width() <= 991) {
      $('footer.clFooter .menuBox h3').off('click').on('click', function () {
        var $thisMenuBox = $(this).closest('.menuBox');
        var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
        var $thisSvg = $(this).find('svg');
        $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
        $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
        $thisLinks.stop(true, true).slideToggle();
        $thisSvg.toggleClass('rotated');
      });
    } else {
      // Desktop: Show all and unbind click
      $('footer.clFooter .menuBox .menuBoxLinks').show();
      $('footer.clFooter .menuBox h3').off('click');
      $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
    }
  }
  setupFooterAccordion();
  $(window).resize(setupFooterAccordion);
});

// Popup Open

// $('.clBtnDrawer').on('click', function() {
//   $('#cl-popup--overlay, #cl-popup--drawer').addClass('active');
// });

// document.addEventListener('DOMContentLoaded', function () {

//   // Dropdown Link Footer

//   const footerDropLink = document.querySelectorAll('a.dropmenu_footer');

//   footerDropLink.forEach(btn => {
//     btn.addEventListener('click', function (e) {
//       e.preventDefault();
//       const footerDropdown = this.nextElementSibling;

//       if(footerDropdown && footerDropdown.classList.contains('menuBoxLinks-detail')){
//         this.classList.toggle('active');
//         footerDropdown.classList.toggle('active');
//       }
//     });
//   });


//   // Accessibility

// //   const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
// //   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
// //   const videoFirst = document.querySelector('.video-desktop video');
// //   const videoSeconde = document.querySelector('.video-mobile video');
// //   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
// //   const videoOn = document.querySelector('.video-on');
// //   const videoOff = document.querySelector('.video-pause');

// //  toggleLabel.forEach(btn => {
// //   btn.addEventListener('click', function() {
// //     const isActive = this.classList.toggle('active'); // toggle only clicked button

// //     // Update media elements
// //     mediaElements.forEach(el => {
// //       el.style.filter = isActive ? 'brightness(0.5)' : '';
// //     });

// //     // Update videos
// //     if(isActive){
// //       videoOff.style.display = 'inline-flex';
// //       videoOn.style.display = 'none';
// //       videoFirst.pause();
// //       videoSeconde.pause();
// //     } else {
// //       videoOff.style.display = 'none';
// //       videoOn.style.display = 'inline-flex';
// //       videoFirst.play();
// //       videoSeconde.play();
// //     }

// //     // Update all banner overlays
// //     btmOverlays.forEach(overlay => {
// //       if(isActive){
// //         overlay.classList.add('active');
// //       } else {
// //         overlay.classList.remove('active');
// //       }
// //     });
// //   });
// // });
// const savedState = sessionStorage.getItem('videoPaused') === 'true';

// // --- Helper function to apply state ---
// function applyVideoState(isPaused) {
//   const toggleLabels = document.querySelectorAll('.cl-accessibility__toggle-label');
//   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
//   const videoFirst = document.querySelector('.video-desktop video');
//   const videoSeconde = document.querySelector('.video-mobile video');
//   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
//   const videoOn = document.querySelector('.video-on');
//   const videoOff = document.querySelector('.video-pause');

//   // Apply toggle button state
//   toggleLabels.forEach(btn => btn.classList.toggle('active', isPaused));

//   // Apply media filter
//   mediaElements.forEach(el => el.style.filter = isPaused ? 'brightness(0.5)' : '');

//   // Videos
//   if(videoFirst && videoSeconde && videoOn && videoOff){
//     if(isPaused){
//       videoFirst.pause();
//       videoSeconde.pause();
//       videoOn.style.display = 'none';
//       videoOff.style.display = 'inline-flex';
//     } else {
//       videoFirst.play();
//       videoSeconde.play();
//       videoOn.style.display = 'inline-flex';
//       videoOff.style.display = 'none';
//     }
//   }

//   // Banner overlays
//   btmOverlays.forEach(overlay => overlay.classList.toggle('active', isPaused));
// }

// // --- Apply saved state on page load ---
// applyVideoState(savedState);

// // --- Attach click handler if toggle exists ---
// const toggleLabels = document.querySelectorAll('.cl-accessibility__toggle-label');
// if(toggleLabels.length > 0){
//   toggleLabels.forEach(btn => {
//     btn.addEventListener('click', function() {
//       const isActive = this.classList.toggle('active');
//       sessionStorage.setItem('videoPaused', isActive);
//       applyVideoState(isActive);
//     });
//   });
// }


// });
document.addEventListener('DOMContentLoaded', function () {

  // Dropdown Link Footer

  const footerDropLink = document.querySelectorAll('a.dropmenu_footer');

  footerDropLink.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const footerDropdown = this.nextElementSibling;

      if(footerDropdown && footerDropdown.classList.contains('menuBoxLinks-detail')){
        this.classList.toggle('active');
        footerDropdown.classList.toggle('active');
      }
    });
  });


  // Accessibility

//   const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
//   const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
//   const videoFirst = document.querySelector('.video-desktop video');
//   const videoSeconde = document.querySelector('.video-mobile video');
//   const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
//   const videoOn = document.querySelector('.video-on');
//   const videoOff = document.querySelector('.video-pause');

//  toggleLabel.forEach(btn => {
//   btn.addEventListener('click', function() {
//     const isActive = this.classList.toggle('active'); // toggle only clicked button

//     // Update media elements
//     mediaElements.forEach(el => {
//       el.style.filter = isActive ? 'brightness(0.5)' : '';
//     });

//     // Update videos
//     if(isActive){
//       videoOff.style.display = 'inline-flex';
//       videoOn.style.display = 'none';
//       videoFirst.pause();
//       videoSeconde.pause();
//     } else {
//       videoOff.style.display = 'none';
//       videoOn.style.display = 'inline-flex';
//       videoFirst.play();
//       videoSeconde.play();
//     }

//     // Update all banner overlays
//     btmOverlays.forEach(overlay => {
//       if(isActive){
//         overlay.classList.add('active');
//       } else {
//         overlay.classList.remove('active');
//       }
//     });
//   });
// });
// -------- Selectors --------
const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
const videoFirst = document.querySelector('.video-desktop video');
const videoSeconde = document.querySelector('.video-mobile video');
const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
const videoOn = document.querySelector('.video-on');
const videoOff = document.querySelector('.video-pause');

// -------- Restore state on page load --------
function restoreVideoState() {
  const savedState = sessionStorage.getItem('videoState');

  const handleVideo = (video) => {
    video.muted = true;
    video.setAttribute('playsinline', '');

    if(savedState === 'paused'){
      // Play briefly then pause
      video.play().finally(() => {
        setTimeout(() => {
          safePause(video);
          // Apply blur & overlays only after stopping
          applyPauseStateUI();
        }, 50); // tiny play duration
      });
    } else {
      safePlay(video); // just play normally
    }
  }

  [videoFirst, videoSeconde].forEach(video => {
    if(video){
      if(video.readyState >= 1){
        handleVideo(video);
      } else {
        video.addEventListener('loadedmetadata', () => handleVideo(video));
      }
    }
  });

  // Toggle button state on load
  toggleLabel.forEach(btn => {
    if(savedState === 'paused') btn.classList.add('active');
    else btn.classList.remove('active');
  });
}

// -------- Toggle click --------
toggleLabel.forEach(btn => {
  btn.addEventListener('click', function() {
    const isActive = this.classList.toggle('active');

    // sync all toggle buttons
    toggleLabel.forEach(b => {
      if(isActive) b.classList.add('active');
      else b.classList.remove('active');
    });

    if(isActive){
      sessionStorage.setItem('videoState','paused');
      applyPauseState(); 
    } else {
      sessionStorage.setItem('videoState','playing');
      applyPlayState();
    }
  });
});

// -------- Functions --------
function applyPauseStateUI(){
  mediaElements.forEach(el => el.style.filter = 'brightness(0.5)');
  if(videoOff) videoOff.style.display = 'inline-flex';
  if(videoOn) videoOn.style.display = 'none';
  btmOverlays.forEach(overlay => overlay.classList.add('active'));
}

function applyPauseState(){
  [videoFirst, videoSeconde].forEach(v => v && safePause(v));
  applyPauseStateUI();
}

function applyPlayState(){
  mediaElements.forEach(el => el.style.filter = '');
  [videoFirst, videoSeconde].forEach(v => v && safePlay(v));
  if(videoOff) videoOff.style.display = 'none';
  if(videoOn) videoOn.style.display = 'inline-flex';
  btmOverlays.forEach(overlay => overlay.classList.remove('active'));
}

// -------- Helpers --------
function safePause(video){
  video.pause();
  video.muted = true;
  video.setAttribute('playsinline', '');
}

function safePlay(video){
  video.muted = true;
  video.setAttribute('playsinline', '');
  video.play().catch(() => {
    setTimeout(() => video.play().catch(()=>{}), 500);
  });
}

// -------- Initialize --------
restoreVideoState();
});